import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-arrow",
  "use": "icon-left-arrow-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left-arrow\">\r\n<path d=\"M5 9.00073L1 5.00073L5 1.00073\" stroke=\"#696974\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol